import React, { FC } from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { font } from '@styles/fonts';
import { scale } from '@components/frame';
import i18n from 'i18n-js';
import { WithColor } from '@styles/colors';

interface ErrorStateProps extends WithColor {
  error: string;
  onClose?: () => void;
  onRetry?: () => void;
}

const ErrorState: FC<ErrorStateProps> = ({ C, error, onClose, onRetry }) => {
  return (
    <View style={[styles.container, { backgroundColor: 'transparent' }]}>
      <View style={[styles.errorBox, { backgroundColor: C('Background/Light/Secondary') }]}>
        <Text style={[font.Headline, { color: C('Label/Light/Primary'), marginBottom: scale(12) }]}>
          {i18n.t('Error Loading Comparison')}
        </Text>
        <Text style={[font.Body, { color: C('Label/Light/Secondary'), marginBottom: scale(24), textAlign: 'center' }]}>
          {error}
        </Text>

        <View style={styles.buttonRow}>
          {onClose && (
            <TouchableOpacity
              style={[
                styles.button,
                {
                  backgroundColor: C('Background/Light/Primary'),
                  borderWidth: scale(1),
                  borderColor: C('Separator/Light/Opaque'),
                },
              ]}
              onPress={onClose}
            >
              <Text style={[font.Body, { color: C('Label/Light/Primary') }]}>
                {i18n.t('Close')}
              </Text>
            </TouchableOpacity>
          )}

          {onRetry && (
            <TouchableOpacity
              style={[
                styles.button,
                {
                  backgroundColor: C('Link/Light/Primary'),
                },
              ]}
              onPress={onRetry}
            >
              <Text style={[font.Body, { color: 'white' }]}>
                {i18n.t('Retry')}
              </Text>
            </TouchableOpacity>
          )}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: scale(20),
  },
  errorBox: {
    padding: scale(24),
    borderRadius: scale(12),
    maxWidth: scale(400),
    alignItems: 'center',
  },
  buttonRow: {
    flexDirection: 'row',
    gap: scale(12),
  },
  button: {
    paddingVertical: scale(12),
    paddingHorizontal: scale(24),
    borderRadius: scale(8),
    minWidth: scale(100),
    alignItems: 'center',
  },
});

export default ErrorState;
